export default "__VITE_ASSET__CedmB5A7__"